import { types } from "../../types/types";
import {remplazarPorTildeASinTilde,filter} from '../../helpers/Buscador'


const initialState = {
cargada:false,
  items: [],
  itemsAux:[],
  loading: false,
  error: null
};

export const contactosReducer = (state = initialState, action) => {    
    switch (action.type) {
      case types.contactosWebTraerStart:
        return {
          ...state,
          loading: true,
          error: null,
          cargada:false
        };
        case types.contactosWebTraerSuccess:
          return {
            ...state,
            loading: false,
            error: null,
            cargada:true,
            items:action.payload,
            itemsAux:action.payload
          };
          case types.buscarContactosWeb:
            var lista = state.itemsAux.filter(n => filter(remplazarPorTildeASinTilde(n.apellido_y_nombre),remplazarPorTildeASinTilde(action.payload)))
            return {
              ...state,
              loading: true,
              error: null,
              cargada:true,
              items: lista
            };
          case types.contactosValidos:
            return {
              ...state,
              items: state.items.filter(n=> n.estado===2)
            };
          case types.contactosPendientes:
            return {
              ...state,
              items: state.items.filter(n=> n.estado===1)
            };
        default:
          return state;
      }
};
